import React, { FC } from 'react';
import BeamerChangelog from 'components/navigation/verticalNavigation/userActionsMenu/BeamerChangelog';
import Notifications from 'components/navigation/verticalNavigation/userActionsMenu/Notifications';
import HelpCenter from './HelpCenter';
import Settings from './Settings';

type Props = {};

const UserSubActions: FC<Props> = () => {
  return (
    <div className="tw-flex tw-flex-col tw-gap-y-3">
      <BeamerChangelog />
      <Notifications />
      <HelpCenter />
      <Settings />
    </div>
  );
};

export default UserSubActions;
